import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {AutomationRuleContainerModel} from "../../../../../../../models/aggregates/alg/cc/automation-rule";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
  
@Injectable({providedIn: "root"})
export class AutomationRuleService extends BaseApiTemplateService<AutomationRuleContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'automation-rules';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'automation-rules';
    this.httpClient = http;
  }
}